import { DateArg, formatDate, isWeekend } from "date-fns";

export function shouldHideTask(date: DateArg<Date>, condition?: string | null): boolean {
  if (!condition) {
    return false;
  }

  if (formatDate(date, "EEE").toLowerCase() === condition) {
    return false;
  }

  if (formatDate(date, "EEEE").toLowerCase() === condition) {
    return false;
  }

  if (condition === "weekday" && isWeekend(date) === false) {
    return false;
  }

  if (condition === "weekend" && isWeekend(date) === true) {
    return false;
  }

  return true;
}
